export const MARTIN_URL = import.meta.env.VITE_MARTIN_URL || `${import.meta.env.VITE_API_ORIGIN}/tiles`;
